export enum RequestMethods {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT',
  PATCH = 'PATCH',
}

export type ResponseType = 'arraybuffer' | 'blob' | 'json' | 'text';

export interface IRequestOptions {
  avoidBlockUI?: boolean;
  showLoading?: boolean;
  headers?: { [name: string]: string };
  responseType?: ResponseType;
  timeout?: number | boolean;
}

export interface IResponseBody<T> {
  data: T;
  operationResult?: any;
}

export interface IErrorResponseBody {
  error: any;
  status: number;
  code: number;
  message: string;
  url: string;
}
